export default __webpack_public_path__ + "cad2213f2cac19b7454eaa1499998dbb.png";